import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Stack,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  OutlinedInput,
  Chip,
  Switch,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiManager } from "../Services/Networking";
import { X } from "lucide-react";
import Layout from "../Components/Layout";

function validatePassword(pw) {
  return (
    /[A-Z]/.test(pw) &&
    /[a-z]/.test(pw) &&
    /[0-9]/.test(pw) &&
    /[^A-Za-z0-9]/.test(pw) &&
    pw.length > 6
  );
}

export default function EmployeeForm() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const isEdit = !!state?.employee;
  const fullList = state?.fullList || [];

  const [departments, setDepartments] = useState([]);
  const [accessGroups, setAccessGroups] = useState([]);
  const [softwareAccess, setSoftwareAccess] = useState([]);
  const [assignedDepartment, setAssignedDepartment] = useState([]);

  const [oldSoftwareAccess, setOldSoftwareAccess] = useState([]);
  const [oldAssignedDepartment, setOldAssignedDepartment] = useState([]);

  const [otpSent, setOtpSent] = useState(false);
  const [hasVerifiedOTP, setHasVerifiedOTP] = useState(isEdit);
  const [otp, setOtp] = useState("");
  const [supabaseId, setSupabaseId] = useState("");

  const [formData, setFormData] = useState({
    emp_name: state?.employee?.emp_name || "",
    emp_id: state?.employee?.emp_id || "",
    mobile: state?.employee?.mobile || "",
    email: state?.employee?.email || "",
    role: state?.employee?.role || "",
    password: "",
    date_of_joining: state?.employee?.date_of_joining
      ? state.employee.date_of_joining.split("T")[0]
      : "",
    sick_leave: state?.employee?.sick_leave || 12,
    casual_leave: state?.employee?.casual_leave || 12,
    paid_leave: state?.employee?.paid_leave || 20,
    week_off: state?.employee?.week_off || 52,
  });

  useEffect(() => {
    const fetchMetadata = async () => {
      const [deptRes, accessRes] = await Promise.all([
        ApiManager.getDepartments(),
        ApiManager.getSoftwareAccess(),
      ]);
      if (deptRes.status === "success") setDepartments(deptRes.data);
      if (accessRes.status === "success") setAccessGroups(accessRes.data);

      if (isEdit) {
        const [allSoftwareAccess, AllDepartmets] = await Promise.all([
          ApiManager.getEmployeeSoftwareAccess(),
          ApiManager.getEmployeeDepartments(),
        ]);
        if (allSoftwareAccess.status === "success") {
          const selectedSoftware = allSoftwareAccess.data.filter(
            (data) => data.emp_id == formData.emp_id,
          );
          setSoftwareAccess(
            selectedSoftware.map((x) => x.software_access_name),
          );
          setOldSoftwareAccess(
            selectedSoftware.map((x) => x.software_access_name),
          );
        }
        if (AllDepartmets.status === "success") {
          const selectedDepartment = AllDepartmets.data.filter(
            (data) => data.emp_id == formData.emp_id,
          );
          setAssignedDepartment(selectedDepartment.map((x) => x.dept_name));
          setOldAssignedDepartment(selectedDepartment.map((x) => x.dept_name));
        }
      }
    };
    fetchMetadata();
  }, []);

  const handleSave = async () => {
    let payload = { ...formData, mobile: `+91${formData.mobile}` };

    if (leaveMode === "per_year") {
      const calculated = getCalculatedLeaves();
      payload = { ...payload, ...calculated };
    }

    if (isEdit && !payload.password) delete payload.password;
    const res = isEdit
      ? await ApiManager.updateEmployee(state.employee.id, payload)
      : await ApiManager.createEmployee({
          ...payload,
          supabase_id: supabaseId,
        });

    if (res.status === "success") {
      const updatedList = isEdit
        ? fullList.map((e) => (e.id === state.employee.id ? res.data : e))
        : [...fullList, res.data];

      if (isEdit) {
        const empId = res.data.emp_id;
        const initialDepts = oldAssignedDepartment;
        const addedDepts = assignedDepartment.filter(
          (d) => !initialDepts.includes(d),
        );
        const removedDepts = initialDepts.filter(
          (d) => !assignedDepartment.includes(d),
        );
        addedDepts.forEach((name) => {
          const dept = departments.find((d) => d.name === name);
          if (dept)
            ApiManager.updateDeptEmployees(dept.dept_id, { add: empId });
        });
        removedDepts.forEach((name) => {
          const dept = departments.find((d) => d.name === name);
          if (dept)
            ApiManager.updateDeptEmployees(dept.dept_id, { delete: empId });
        });
        const initialSA = oldSoftwareAccess;
        const addedSA = softwareAccess.filter((s) => !initialSA.includes(s));
        const removedSA = initialSA.filter((s) => !softwareAccess.includes(s));
        addedSA.forEach((name) => {
          const sa = accessGroups.find((g) => g.name === name);
          if (sa) ApiManager.updateSoftwareEmployees(sa.id, { add: empId });
        });
        removedSA.forEach((name) => {
          const sa = accessGroups.find((g) => g.name === name);
          if (sa) ApiManager.updateSoftwareEmployees(sa.id, { delete: empId });
        });
      } else {
        //only add is done
        const toAddDepartments = assignedDepartment.map((x) =>
          departments.find((y) => y.name == x),
        );
        if (toAddDepartments && toAddDepartments.length > 0) {
          toAddDepartments.forEach((dept) => {
            ApiManager.updateDeptEmployees(dept.dept_id, {
              add: res.data.emp_id,
            });
          });
        }
        const toAddSA = softwareAccess.map((x) =>
          accessGroups.find((y) => y.name == x),
        );
        if (toAddSA && toAddSA.length > 0) {
          debugger;
          toAddSA.forEach((sa) => {
            ApiManager.updateSoftwareEmployees(sa.id, {
              add: res.data.emp_id,
            });
          });
        }
      }
      navigate("/employees", { state: { updatedList } });
    }
  };

  const handleSendOtp = async () => {
    if (!validatePassword(formData.password)) {
      alert("Please check the password.");
    }
    console.log(formData.mobile);

    if (formData.mobile.length != 10) {
      alert("Please fill valid 10 digit phone number.");
      return;
    }

    const payload = {
      phone: `+91${formData.mobile}`,
      password: formData.password,
      emp_id: formData.emp_id,
      name: formData.emp_name,
      email: formData.email,
    };
    const res = await ApiManager.signUp(payload);
    if (res.success) {
      setOtpSent(true);
    } else {
      alert(res.message);
    }
  };

  const handleVerifyOTP = async () => {
    const verifyPayload = {
      phone: `+91${formData.mobile}`,
      token: otp,
      emp_id: formData.emp_id,
      name: formData.emp_name,
      email: formData.email,
    };
    const verifyRes = await ApiManager.verifyOTP(verifyPayload);
    if (verifyRes.success) {
      debugger;
      setSupabaseId(verifyRes.data.user.supabase_id);
      setHasVerifiedOTP(true);
    } else {
      alert(verifyRes.message);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [leaveMode, setLeaveMode] = useState("per_year");

  const handleLeaveModeToggle = (e) => {
    setLeaveMode(e.target.checked ? "rest_of_year" : "per_year");
  };

  const getCalculatedLeaves = () => {
    if (!formData.date_of_joining) return { ...formData };

    const joining = new Date(formData.date_of_joining);
    const year = joining.getFullYear();
    const start = joining;
    const end = new Date(year, 11, 31);

    const totalDaysInYear =
      year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 366 : 365;
    const remainingDays = Math.max(
      0,
      (end - start) / (1000 * 60 * 60 * 24) + 1,
    );
    const factor = remainingDays / totalDaysInYear;

    return {
      sick_leave: Math.round(Number(formData.sick_leave) * factor),
      casual_leave: Math.round(Number(formData.casual_leave) * factor),
      paid_leave: Math.round(Number(formData.paid_leave) * factor),
      week_off: Math.round(Number(formData.week_off) * factor),
    };
  };

  const proRated = getCalculatedLeaves();

  return (
    <Layout name={isEdit ? "EDIT EMPLOYEE" : "ADD EMPLOYEE"}>
      <Box maxWidth="lg" sx={{ p: 4, width: "100%" }}>
        <Stack direction="row" justifyContent="flex-end" spacing={2} mb={4}>
          <Typography variant="h4" mb={3}>
            {isEdit ? "Edit Employee" : "Add Employee"}
          </Typography>
          <span style={{ flex: 1 }}></span>
          <Button
            onClick={() =>
              navigate("/employees", { state: { updatedList: fullList } })
            }
          >
            Cancel
          </Button>
          <Button
            disabled={!hasVerifiedOTP}
            variant="contained"
            sx={{ bgcolor: "#00c853" }}
            onClick={handleSave}
          >
            {isEdit ? "Update" : "Save"}
          </Button>
        </Stack>
        <Grid size={12} md={4}>
          <Typography variant="h3">Basic Details</Typography>
        </Grid>
        <br />
        <Grid container spacing={2}>
          <Grid size={12} md={4}>
            <Typography mb={1}>Employee Name</Typography>
            <TextField
              fullWidth
              name="emp_name"
              size="small"
              value={formData.emp_name}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>Employee ID</Typography>
            <TextField
              fullWidth
              name="emp_id"
              size="small"
              value={formData.emp_id}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>Mobile</Typography>
            <TextField
              fullWidth
              name="mobile"
              size="small"
              value={formData.mobile}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>Email</Typography>
            <TextField
              fullWidth
              name="email"
              size="small"
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>
              Password {isEdit && "(Leave blank to keep current)"}
            </Typography>
            <Stack direction="row" spacing={2}>
              <TextField
                fullWidth
                name="password"
                size="small"
                value={formData.password}
                onChange={handleChange}
              />

              {otpSent ? (
                <>
                  <TextField
                    fullWidth
                    label="Enter OTP"
                    value={otp}
                    style={{ display: hasVerifiedOTP ? "none" : "block" }}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    onClick={handleVerifyOTP}
                    style={{
                      width: "200px",
                      display: hasVerifiedOTP ? "none" : "block",
                    }}
                    disabled={!formData.mobile || !formData.password}
                  >
                    Verify OTP
                  </Button>
                </>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleSendOtp}
                  style={{
                    width: "200px",
                    display: hasVerifiedOTP ? "none" : "block",
                  }}
                  disabled={!formData.mobile || !formData.password}
                >
                  Send OTP
                </Button>
              )}
            </Stack>
          </Grid>

          <br />
          <Grid size={12} md={4}>
            <Typography variant="h3">Organisation</Typography>
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>Role</Typography>
            <TextField
              fullWidth
              name="role"
              size="small"
              value={formData.role}
              onChange={handleChange}
            />
          </Grid>

          <Grid size={12} md={4}>
            <Typography mb={1}>Department</Typography>
            <FormControl fullWidth>
              <Select
                multiple
                value={assignedDepartment}
                onChange={(e) => {
                  setAssignedDepartment(e.target.value);
                }}
                input={<OutlinedInput size="small" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => (
                      <Chip
                        key={id}
                        label={id}
                        size="small"
                        onDelete={() =>
                          setAssignedDepartment((prev) =>
                            prev.filter((i) => i !== id),
                          )
                        }
                        deleteIcon={<X size={14} />}
                        onMouseDown={(e) => e.stopPropagation()}
                      />
                    ))}
                  </Box>
                )}
              >
                {departments.map((d) => (
                  <MenuItem key={d.dept_id} value={d.name}>
                    {d.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>Software Access</Typography>

            <FormControl fullWidth>
              <Select
                multiple
                value={softwareAccess}
                onChange={(e) => {
                  setSoftwareAccess(e.target.value);
                }}
                input={<OutlinedInput size="small" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => (
                      <Chip
                        key={id}
                        label={id}
                        size="small"
                        onDelete={() =>
                          setSoftwareAccess((prev) =>
                            prev.filter((i) => i !== id),
                          )
                        }
                        deleteIcon={<X size={14} />}
                        onMouseDown={(e) => e.stopPropagation()}
                      />
                    ))}
                  </Box>
                )}
              >
                {accessGroups.map((g) => (
                  <MenuItem key={g.name} value={g.name}>
                    {g.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12} md={4}>
            <Typography mb={1}>Joining Date</Typography>
            <TextField
              fullWidth
              name="date_of_joining"
              type="date"
              size="small"
              value={formData.date_of_joining}
              onChange={handleChange}
            />
          </Grid>
          <br />
          <Grid size={12} md={4}>
            <Typography variant="h3">Leave Allocation</Typography>
          </Grid>
          <Grid size={12} display="flex" alignItems="center" gap={1}>
            <Typography>Leave For year</Typography>
            <Switch
              checked={leaveMode === "rest_of_year"}
              onChange={handleLeaveModeToggle}
            />
            <Typography>Leave for rest of year</Typography>
          </Grid>
          <Grid size={12} md={3}>
            <Typography mb={1}>Sick Leave</Typography>
            <TextField
              fullWidth
              name="sick_leave"
              type="number"
              size="small"
              value={formData.sick_leave}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={3}>
            <Typography mb={1}>Casual Leave</Typography>
            <TextField
              fullWidth
              name="casual_leave"
              type="number"
              size="small"
              value={formData.casual_leave}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={3}>
            <Typography mb={1}>Paid Leave</Typography>
            <TextField
              fullWidth
              name="paid_leave"
              type="number"
              size="small"
              value={formData.paid_leave}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12} md={3}>
            <Typography mb={1}>Week Offs</Typography>
            <TextField
              fullWidth
              name="week_off"
              type="number"
              size="small"
              value={formData.week_off}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12}>
            {leaveMode === "per_year" && formData.date_of_joining && (
              <Box
                sx={{
                  mt: 1,
                  p: 2,
                  bgcolor: "#f0f7ff",
                  border: "1px solid #c2e0ff",
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2" color="primary.main">
                  <strong>
                    Pro-rated for{" "}
                    {new Date(formData.date_of_joining).getFullYear()}:
                  </strong>
                  Since the employee joins on {formData.date_of_joining}, they
                  will be allocated
                  <b> {proRated.sick_leave}</b> Sick,{" "}
                  <b> {proRated.casual_leave}</b> Casual,
                  <b> {proRated.paid_leave}</b> Paid, and{" "}
                  <b> {proRated.week_off}</b> Week-offs.
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
